import React, { useState } from 'react';
import {
  Box,
  Select,
  MenuItem,
  FormControl,
  Typography,
  Chip,
  Tooltip,
} from '@mui/material';
import {
  Business,
  ExpandMore,
} from '@mui/icons-material';
import { useSite } from '../utils/SiteContext';

const SiteSelector = ({ variant = 'header' }) => {
  const { 
    currentSite, 
    sites, 
    setCurrentSite, 
    loading 
  } = useSite();

  const getCurrentSiteData = () => {
    return sites.find(site => site.id === currentSite) || null;
  };

  const handleSiteChange = (event) => {
    setCurrentSite(event.target.value);
  };

  if (loading || sites.length === 0) {
    return null;
  }

  const currentSiteData = getCurrentSiteData();

  if (variant === 'header') {
    return (
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        minWidth: 200,
        mr: 2
      }}>
        <Business sx={{ mr: 1, color: '#6b7280', fontSize: 20 }} />
        <FormControl size="small" sx={{ minWidth: 160 }}>
          <Select
            value={currentSite || ''}
            onChange={handleSiteChange}
            displayEmpty
            sx={{
              color: '#374151',
              fontSize: '0.875rem',
              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
              '& .MuiSelect-select': {
                padding: '6px 12px',
                display: 'flex',
                alignItems: 'center',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                border: '1px solid #d1d5db',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                border: '1px solid #2563eb',
              },
            }}
            IconComponent={ExpandMore}
          >
            {sites.map((site) => (
              <MenuItem key={site.id} value={site.id}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {site.name}
                  </Typography>
                  <Typography variant="caption" sx={{ color: '#6b7280' }}>
                    {site.location}
                  </Typography>
                </Box>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        
        {currentSiteData && (
          <Chip
            label={currentSiteData.stats?.totalAnalyses || 0}
            size="small"
            sx={{
              ml: 1,
              backgroundColor: '#f3f4f6',
              color: '#374151',
              fontSize: '0.75rem',
              height: 20,
            }}
          />
        )}
      </Box>
    );
  }

  // Compact variant for smaller spaces
  return (
    <Tooltip title={currentSiteData?.name || 'No site selected'}>
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <Select
          value={currentSite || ''}
          onChange={handleSiteChange}
          displayEmpty
          sx={{
            fontSize: '0.875rem',
            '& .MuiSelect-select': {
              padding: '4px 8px',
            },
          }}
        >
          {sites.map((site) => (
            <MenuItem key={site.id} value={site.id}>
              {site.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Tooltip>
  );
};

export default SiteSelector;
